import { CustomFieldInitialStateType } from "../types/initialStateType";

export const customFieldIinitialState: CustomFieldInitialStateType = {
  containerId: undefined,
  customFields: undefined,
  relatedEntityData: undefined,
};
